(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["academy-library"]) return;
  try {
    
  (function () {
    var tabs = document.querySelectorAll('.pr-filter-tab');
    var grid = document.getElementById('pr-category-grid');
    if (!tabs.length || !grid) return;

    var cards = grid.querySelectorAll('.pr-card');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('pr-filter-tab--active');
        });
        tab.classList.add('pr-filter-tab--active');

        var filter = tab.getAttribute('data-filter');

        cards.forEach(function (card) {
          var difficulty = card.getAttribute('data-difficulty');
          if (filter === 'all' || difficulty === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teacher-training-library"]) return;
  try {
    
  (function () {
    var tabs = document.querySelectorAll('.tt-filter-tab');
    var grid = document.getElementById('tt-category-grid');
    if (!tabs.length || !grid) return;

    var cards = grid.querySelectorAll('.tt-card');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('tt-filter-tab--active');
        });
        tab.classList.add('tt-filter-tab--active');

        var filter = tab.getAttribute('data-filter');

        cards.forEach(function (card) {
          var difficulty = card.getAttribute('data-difficulty');
          if (filter === 'all' || difficulty === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
